import Vue from 'vue';
import './plugins/vuetify'
import DashboardPlugin from './plugins/dashboard-plugin';
import ElementUI from 'element-ui';
import 'flag-icon-css/css/flag-icon.min.css';
// In your main vue file - the one where you create the initial vue instance.
import VuePlyr from 'vue-plyr'
import 'vue-plyr/dist/vue-plyr.css' // only if your build system can import css, otherwise import it wherever you would import your css.
// router setup
import router from './routes/router';
import i18n from './i18n';
//Vue Authenticate setup
import VueAxios from 'vue-axios'
import VueAuthenticate from 'vue-authenticate'
import axios from 'axios';
import store from './store'
import App from './App.vue';

import moment from 'moment';
import 'moment-duration-format';
import 'moment-timezone';

Vue.prototype.moment = moment;

import VueTelInput from 'vue-tel-input'
import 'vue-tel-input/dist/vue-tel-input.css';
import 'sweetalert2/dist/sweetalert2.css'
import LightTimeline from 'vue-light-timeline';
import './registerServiceWorker'

import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import {library} from '@fortawesome/fontawesome-svg-core'

import {fal} from '@fortawesome/pro-light-svg-icons'

//Vue Google Analytics
import VueGtag from "vue-gtag";

Vue.use(VueGtag, {
    config: {id: "UA-155394070-1"},
    params: {
        send_page_view: false
    }
}, router);


library.add(fal);

Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.use(LightTimeline);
Vue.prototype.moment = moment;
Vue.use(VuePlyr);

// plugin setup
Vue.use(DashboardPlugin);
Vue.use(ElementUI);
Vue.use(VueTelInput, {validity: true});


Vue.use(VueAxios, axios);
Vue.use(VueAuthenticate, {
    baseUrl: 'https://admin.hoptone.com', // Your API domain

    providers: {
        oauth2: {
            clientId: '2',
            redirectUri: 'http:/localhost:8080/auth/callback' // Your client app URL
        }
    }
});

const token = localStorage.getItem('user-token');
const permissions = sessionStorage.getItem('permissions');

if (permissions) {
    store.commit('customer/SET_PERMISSIONS', permissions);
}
if (token) {
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
}
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*'
axios.defaults.headers.common['Content-Type'] = 'application/json'


Vue.mixin({
    data: function () {
        return {
            get baseAPIURL() {
                const debug = process.env.NODE_ENV !== 'production';

                if (debug) {
                    return 'http://hoptone.test/api/'
                } else {
                    return 'https://admin.hoptone.com/api/'
                }
            },
            get baseURL() {
                const debug = process.env.NODE_ENV !== 'production';

                if (debug) {
                    return 'http://hoptone.test/'
                } else {
                    return 'https://admin.hoptone.com/'
                }
            }
        }
    }
});
/* eslint-disable no-new */
new Vue({
    el: '#app',
    store,
    render: h => h(App),
    router,
    i18n,
});




